import isEqual from 'lodash-es/isEqual'

import { FormModal } from '../../Form'
import {
  DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT,
  DocFlowAddRecipientFields,
} from '../DocFlowAddRecipientFields'

function DocFlowRecipientModal({
  documentId,
  edit,
  initialValues,
  recipientFieldName = DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT,
  title = 'DocumentStapling.ModalAddRecipientTitleKey',
  validationSchema,
  onCloseModal,
  onSubmit,
}) {
  function handleSubmit({ value, ...restArgs }) {
    if (isEqual(initialValues[recipientFieldName], value[recipientFieldName])) {
      onCloseModal()

      return
    }

    onSubmit({ value, ...restArgs })
  }

  return (
    <FormModal
      Fields={DocFlowAddRecipientFields}
      formBodyProps={{
        withNotifications: true,
      }}
      formFieldsProps={{ documentId, edit }}
      formTitle={title}
      initialValues={initialValues}
      recipientFieldName={recipientFieldName}
      validationSchema={validationSchema}
      onClose={onCloseModal}
      onSubmit={handleSubmit}
    />
  )
}

export default DocFlowRecipientModal
